import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45399c5b")

_pushScopeId("data-v-45399c5b")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Live")
const _hoisted_2 = { class: "popular c-white" }
const _hoisted_3 = { class: "d-ib v-middle f-md mr-10" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")
  const _component_TheLiveVideo = _resolveComponent("TheLiveVideo")
  const _component_Icon = _resolveComponent("Icon")
  const _component_TheLiveNotice = _resolveComponent("TheLiveNotice")
  const _component_TheLiveChat = _resolveComponent("TheLiveChat")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, null, {
    left: _withId(() => [
      _createVNode(_component_Pic, {
        src: "membership/full_screen",
        width: "16",
        height: "16",
        class: "anchor",
        onClick: _ctx.fullscreen
      }, null, 8, ["onClick"])
    ]),
    title: _withId(() => [
      _createVNode(_component_t, { path: "membership_7" }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    body: _withId(() => [
      _createVNode(_component_TheLiveVideo, _mergeProps({ address: _ctx.liveAddress }, _ctx.$attrs), null, 16, ["address"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.user), 1),
        _createVNode(_component_Icon, {
          name: "user",
          sm: "",
          style: {"color":"white"}
        })
      ]),
      (_ctx.tip)
        ? (_openBlock(), _createBlock(_component_TheLiveNotice, {
            key: 0,
            content: _ctx.tip
          }, null, 8, ["content"]))
        : _createCommentVNode("", true),
      _createVNode(_component_TheLiveChat, {
        config: _ctx.chatConfig,
        class: "flex-1 scroll-y"
      }, null, 8, ["config"])
    ]),
    _: 1
  }))
})